import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["value", "keyName", "className", "displayDataTypes", "components", "displayObjectSize", "enableClipboard", "highlightUpdates", "objectSortKeys", "indentWidth", "collapsed", "level", "keyid", "quotes", "onCopied", "onExpand", "parentValue", "setParentValue"];
import { Fragment, useId, cloneElement, useState, useEffect } from 'react';
import { ValueView, Colon, Label, Line, typeMap } from './value';
import { TriangleArrow } from './arrow/TriangleArrow';
import { useExpandsStatus, store } from './store';
import { Semicolon } from './semicolon';
import { Copied } from './copied';
import { Ellipsis } from './comps/ellipsis';
import { Meta } from './comps/meta';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CountInfo = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Label, {
    style: {
      paddingLeft: 4,
      fontStyle: 'italic'
    },
    color: "var(--w-rjv-info-color, #0000004d)",
    className: "w-rjv-object-size",
    children: children
  });
};
export function RooNode(props) {
  var _expands$keyid;
  var {
      value = {},
      keyName,
      className,
      displayDataTypes = true,
      components = {},
      displayObjectSize = true,
      enableClipboard = true,
      highlightUpdates = true,
      objectSortKeys = false,
      indentWidth = 15,
      collapsed,
      level = 1,
      keyid = 'root',
      quotes = '"',
      onCopied,
      onExpand,
      parentValue,
      setParentValue
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded);
  var isArray = Array.isArray(value);
  var subkeyid = useId();
  var expands = useExpandsStatus();
  var expand = (_expands$keyid = expands[keyid]) != null ? _expands$keyid : typeof collapsed === 'boolean' ? collapsed : typeof collapsed === 'number' ? level <= collapsed : true;
  var arrowStyle = {
    transform: "rotate(" + (expand ? '0' : '-90') + "deg)",
    transition: 'all 0.3s'
  };
  var handle = () => {
    onExpand && typeof onExpand === 'function' && onExpand({
      expand: !expand,
      keyid,
      keyName,
      value: value
    });
    !expand ? store.expand(keyid) : store.collapse(keyid);
  };
  var [valueData, setValueData] = useState(value);
  var subNodeProps = {
    components,
    indentWidth,
    displayDataTypes,
    displayObjectSize,
    enableClipboard,
    highlightUpdates,
    onCopied,
    onExpand,
    collapsed,
    parentValue: value,
    setParentValue: setValueData,
    quotes,
    level: level + 1,
    style: {
      paddingLeft: indentWidth
    }
  };
  var valueViewProps = {
    displayDataTypes,
    displayObjectSize,
    enableClipboard,
    indentWidth,
    data: valueData,
    quotes,
    setValue: setValueData,
    renderBraces: components.braces,
    renderValue: components.value
  };
  var arrowView = components.arrow ? /*#__PURE__*/cloneElement(components.arrow, {
    style: arrowStyle,
    'data-expand': expand,
    className: "w-rjv-arrow"
  }) : /*#__PURE__*/_jsx(TriangleArrow, {
    style: arrowStyle,
    className: "w-rjv-arrow"
  });
  var [showTools, setShowTools] = useState(false);
  var eventProps = {};
  if (enableClipboard) {
    eventProps.onMouseEnter = () => setShowTools(true);
    eventProps.onMouseLeave = () => setShowTools(false);
  }
  useEffect(() => setValueData(value), [value]);
  var nameKeys = isArray ? Object.keys(valueData).map(m => Number(m)) : Object.keys(valueData);

  // object
  var entries = isArray ? Object.entries(valueData).map(m => [Number(m[0]), m[1]]) : Object.entries(valueData);
  if (objectSortKeys) {
    entries = objectSortKeys === true ? entries.sort((_ref2, _ref3) => {
      var [a] = _ref2;
      var [b] = _ref3;
      return typeof a === 'string' && typeof b === 'string' ? a.localeCompare(b) : 0;
    }) : entries.sort((_ref4, _ref5) => {
      var [a] = _ref4;
      var [b] = _ref5;
      return typeof a === 'string' && typeof b === 'string' ? objectSortKeys(a, b) : 0;
    });
  }
  var countInfo = /*#__PURE__*/_jsxs(CountInfo, {
    children: [nameKeys.length, " items"]
  });
  if (components.countInfo) {
    countInfo = components.countInfo({
      count: nameKeys.length,
      level,
      visible: expand
    }) || countInfo;
  }
  return /*#__PURE__*/_jsxs("div", _extends({}, reset, {
    className: className + " w-rjv-inner"
  }, eventProps, {
    children: [/*#__PURE__*/_jsxs(Line, {
      style: {
        display: 'inline-flex',
        alignItems: 'center'
      },
      onClick: handle,
      children: [arrowView, (typeof keyName === 'string' || typeof keyName === 'number') && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(Semicolon, {
          value: valueData,
          quotes: quotes,
          "data-keys": keyid,
          render: components.objectKey,
          keyName: keyName,
          parentName: keyName,
          color: typeof keyName === 'number' ? typeMap['number'].color : ''
        }), /*#__PURE__*/_jsx(Colon, {})]
      }), /*#__PURE__*/_jsx(Meta, {
        start: true,
        isArray: isArray,
        level: level,
        render: components.braces
      }), !expand && /*#__PURE__*/_jsx(Ellipsis, {
        render: components.ellipsis,
        count: nameKeys.length,
        level: level
      }), !expand && /*#__PURE__*/_jsx(Meta, {
        isArray: isArray,
        level: level,
        render: components.braces
      }), displayObjectSize && countInfo, components.countInfoExtra && components.countInfoExtra({
        count: nameKeys.length,
        level,
        showTools,
        keyName,
        visible: expand,
        value: valueData,
        parentValue,
        setParentValue,
        setValue: setValueData
      }), enableClipboard && /*#__PURE__*/_jsx(Copied, {
        show: showTools,
        text: valueData,
        onCopied: onCopied,
        render: components == null ? void 0 : components.copied
      })]
    }), expand && /*#__PURE__*/_jsx(Line, {
      className: "w-rjv-content",
      style: {
        borderLeft: 'var(--w-rjv-border-left-width, 1px) var(--w-rjv-line-style, solid) var(--w-rjv-line-color, #ebebeb)',
        marginLeft: 6
      },
      children: entries.length > 0 && [...entries].map((_ref6, idx) => {
        var [key, itemVal] = _ref6;
        var item = itemVal;
        var renderKey = /*#__PURE__*/_jsx(Semicolon, {
          value: item,
          "data-keys": keyid,
          quotes: quotes,
          parentName: keyName,
          highlightUpdates: highlightUpdates,
          render: components.objectKey,
          color: typeof key === 'number' ? typeMap['number'].color : '',
          keyName: key
        });
        var isEmpty = Array.isArray(item) && item.length === 0 || typeof item === 'object' && item && !(item instanceof Date) && Object.keys(item).length === 0;
        if (Array.isArray(item) && !isEmpty) {
          var label = isArray ? idx : key;
          return /*#__PURE__*/_jsx(Line, {
            className: "w-rjv-wrap",
            children: /*#__PURE__*/_jsx(RooNode, _extends({
              value: item,
              keyName: label,
              keyid: keyid + subkeyid + label
            }, subNodeProps))
          }, label + idx);
        }
        if (typeof item === 'object' && item && !(item instanceof Date) && !isEmpty) {
          return /*#__PURE__*/_jsx(Line, {
            className: "w-rjv-wrap",
            children: /*#__PURE__*/_jsx(RooNode, _extends({
              value: item,
              keyName: key,
              keyid: keyid + subkeyid + key
            }, subNodeProps))
          }, key + '' + idx);
        }
        if (typeof item === 'function') {
          return;
        }
        return /*#__PURE__*/_jsx(ValueView, _extends({}, valueViewProps, {
          renderKey: renderKey,
          keyName: key,
          value: item
        }), idx);
      })
    }), expand && /*#__PURE__*/_jsx(Line, {
      style: {
        paddingLeft: 2
      },
      children: /*#__PURE__*/_jsx(Meta, {
        render: components.braces,
        isArray: isArray,
        level: level,
        style: {
          paddingLeft: 2,
          display: 'inline-block'
        }
      })
    })]
  }));
}